<div class="page" [attr.dir]="direction" [class.no-logo]="!hasLogo()">
  <div class="logo-top" *ngIf="hasLogo()">
	<div class="logo-wrap" id="logoBox">
	  <ng-container *ngIf="invoiceData?.logo_base64">
		<img [src]="invoiceData.logo_base64" alt="logo" />
	  </ng-container>
	  <ng-container *ngIf="!invoiceData?.logo_base64 && invoiceData?.company?.logo_url">
		<img [src]="invoiceData.company.logo_url" alt="logo" />
	  </ng-container>
	</div>
  </div>

  <div class="header">
			<div class="company">
				<div style="font-weight:700">{{ getCompanyName() }}</div>
				<ng-container *ngIf="getFormattedVatIdLines() && getFormattedVatIdLines().length > 0">
					<div class="muted" *ngFor="let vatLine of getFormattedVatIdLines()">{{ vatLine }}</div>
				</ng-container>
				<div class="muted" *ngIf="getCompanyPhone()">{{ translateKeyLocal('companies.table.headers.phone') }}: {{ getCompanyPhone() }}</div>
			</div>

			<div class="title">
				<div class="doc-title">{{ getInvoiceTypeName() }} <span class="badge">{{ translateKeyLocal('documentNumber') }} {{ invoiceData?.document_number || invoiceData?.copyVersion || '1' }}</span></div>
				<div class="warning" *ngIf="invoiceData?.warning">{{ invoiceData.warning }}</div>
				<!-- Allocation Number Display -->
				<div *ngIf="invoiceData?.confirmation_number" class="allocation-number" style="font-size: 12px; color: #666; margin-top: 5px;">
					<span>{{ getConfirmationNumber().remainingDigits }}<span style="text-decoration: underline;">{{ getConfirmationNumber().last9Digits }}</span></span>
				</div>
			</div>

			<div class="customer">
				<strong>{{ translateKeyLocal('customerName') }}</strong>
				<span class="customer-name">{{ getCustomerName() }}</span>
				<div class="muted" *ngFor="let vatIdLine of getCustomerVatIdLines()" style="font-weight: 500; font-size: 12px;">{{ vatIdLine }}</div>
			</div>
  </div>

  <div class="date-above">{{ getFormattedDate() }}</div>

  <table *ngIf="(invoiceData?.lines && invoiceData.lines.length) || (invoiceData?.soldItems && invoiceData.soldItems.length)">
		<thead>
			<tr>
				<th>{{ translateKeyLocal('productDetails') }}</th>
				<th>{{ translateKeyLocal('price') }}</th>
				<th>{{ translateKeyLocal('documentLines.quantity') }}</th>
				<th>{{ translateKeyLocal('itemDiscountTotal') }}</th>
				<th>{{ translateKeyLocal('subtotal') }}</th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let item of (invoiceData?.lines || invoiceData?.soldItems)">
				<tr>
					<td>
						{{ item.description || item.item_name || item.product_name }}
					</td>
					<td>{{ formatNumber(item.price_per_unit || item.price) }}
						<span class="toggle-indicators">
							<span *ngIf="item.isVatIncluded" class="vat-indicator" 
								  [title]="translateKeyLocal('documentLines.incVat')">
								{{ translateKeyLocal('documentLines.incVat') }}
							</span>
						</span>
					</td>
					<td class="qty">{{ formatNumber(item.quantity) }}</td>
					<td class="qty">{{ item.isPresenting === true ? (direction === 'rtl' ? "%" + formatNumber(item.discount) : formatNumber(item.discount) + "%") : formatNumber(item.discount) }}</td>
					<td class="total">{{ formatNumber(item.sub_total || item.total) }}</td>
				</tr>
			</ng-container>
		</tbody>
  </table>

	<div class="totals" *ngIf="!isReceipt()">
	<div class="box">
	<div class="label">{{ translateKeyLocal('grossTotal') }}</div><div class="value">{{ formatNumber(calculateAmountBeforeDiscount()) }}</div>
	<div class="label">{{ translateKeyLocal('totalProductDiscounts') }}</div><div class="value">{{ formatNumber(calculateTotalDiscounts()) }}</div>
	<div class="label">{{ translateKeyLocal('taxableValue') }}</div><div class="value">{{ formatNumber(calculateTaxableValue()) }}</div>
	<div class="label">{{ translateKeyLocal('invoice.vat') }} ({{ getVatPercentage() }}%)</div><div class="value">{{ formatNumber(calculateVatAmount()) }}</div>
	<div class="label total-due-label">{{ translateKeyLocal('dueBeforeTotalDiscount') }}</div><div class="value total-due-value">{{ formatNumber(getPaymentAmountIncludingVat()) }}</div>
	</div>
  </div>

	<div class="payments" *ngIf="invoiceData?.receiptsDetails && invoiceData.receiptsDetails.length">
		<h3>{{ translateKeyLocal('paymentDetails') }}</h3>
	<table class="payment-table">
			<thead>
				<tr>
					<th>{{ translateKeyLocal('invoice.payment.method') }}</th>
					<th>{{ translateKeyLocal('dueDate') }}</th>
					<th>{{ translateKeyLocal('invoice.payment.amount') }}</th>
				</tr>
			</thead>
	  <tbody>
		<tr *ngFor="let r of invoiceData.receiptsDetails">
			<td class="method">{{ getPaymentMethodName(r.payment_type) }}</td>
			<td class="due">{{ r.date || '-' }}</td>
			<td class="amount" [ngClass]="{'deduction-amount': r.payment_type === 5 && !isReceipt()}">
				{{ formatNumber(r.amount) }}
			</td>
		</tr>
		<!-- Show deduction_from_source if it exists but not in receiptsDetails -->
		<tr *ngIf="getDeductionAmount() > 0 && !hasDeductionInReceiptsDetails()">
			<td class="method">{{ getPaymentMethodName(5) }}</td>
			<td class="due">-</td>
			<td class="amount" [ngClass]="{'deduction-amount': !isReceipt()}">
				{{ formatNumber(getDeductionAmount()) }}
			</td>
		</tr>
	  </tbody>
			<tfoot>
				<tr>
					<td colspan="2" class="label-total">{{ translateKeyLocal('totalAmountReceived') }}</td>
					<td class="amount" style="font-weight:700;">{{ formatNumber(getPaymentAmountIncludingVat()) }}</td>
				</tr>
			</tfoot>
	</table>
  </div>

	<!-- Notes Section -->
	<div *ngIf="invoiceData?.note" class="invoice-note" 
		 style="margin: 20px 0; padding: 0; text-align: center; color: red; font-size: 16px; font-weight: bold;">
		<p style="margin: 0;">** {{ invoiceData.note }} **</p>
	</div>

	<div *ngIf="invoiceData?.invoice_note" class="invoice-note"
		 style="margin-top: 20px; padding: 10px; border: 1px solid #E0E0E0; border-radius: 5px;">
		<h4 style="font-weight: 600; font-size: 14px; margin: 0 0 5px 0;">
			{{ translateKeyLocal('invoice.note') }}:
		</h4>
		<p style="font-size: 14px; font-weight: 300; margin: 5px 0; white-space: pre-line;">{{ invoiceData.invoice_note | formatNoteHtml }}</p>
	</div>

	<!-- <div class="toolbar">
		<button class="btn" (click)="showAgainInvoiceStop()">{{ translateKeyLocal('Share') }}</button>
		<button class="btn" (click)="printPdfLink()">{{ translateKeyLocal('Print') }}</button>
		<button class="btn">{{ translateKeyLocal('Change Language') }}</button>
		<button class="btn red" (click)="printPdfLink()">{{ translateKeyLocal('Download PDF') }}</button>
	</div> -->
</div>
